import React from "react";
import axios from "axios";

// styles
import styles from "./ForgotPassword.module.css";

import ForgotPasswordNotification from "./ForgotPasswordNotification";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      message_type: null,
      email: "",
    };
  }

  sendPasswordEmail(email) {
    axios
      .post("/login/password-reset", { email })
      .then(() => {
        this.setState({
          message: "Please check your email",
          message_type: "success",
        });
      })
      .catch((e) => {
        this.setState({ message: e.response.data.error });
      });
  }

  render() {
    return (
      <>
        {this.state.message_type === "success" ? (
          <ForgotPasswordNotification email={this.state.email} />
        ) : (
          <div className={styles.formContainer}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.sendPasswordEmail(this.state.email);
              }}
            >
              <p className={styles.formTitle}>Forgot Password</p>
              <div className={styles.form}>
                {this.state.message_type !== "success" && (
                  <p className={styles.errorMessage}>{this.state.message}</p>
                )}
                <div>
                  <p className={styles.textContainer}>
                    Fill out the form below to reset your password. An email will
                    be sent to you with a link to reset.
                  </p>
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    value={this.state.email}
                    placeholder="Email"
                    onChange={(event) =>
                      this.setState({ email: event.target.value })
                    }
                  />
                </div>

                <div className={styles.formSubmit}>
                  <button type="submit" className={"btn primary"}>
                    Send
                  </button>

                  <p>
                    Need help?{" "}
                    <a href="mailto:support@treowellness.com">
                      support@treowellness.com
                    </a>
                  </p>
                </div>
              </div>
            </form>
          </div>
        )}
      </>
    );
  }
}

export default ForgotPassword;
